/**
 * theme.ts · 09_APP · OS-006 · 2026-10-20 · D-0072
 * Light or dark, her choice, remembered on this device. Light is the default.
 * Her words: "Sometimes my eyes like the dark better."
 */
export type Theme = "light" | "dark";
const KEY = "c2c-theme";

export function getTheme(): Theme {
  try { return localStorage.getItem(KEY) === "dark" ? "dark" : "light"; } catch { return "light"; }
}

export function applyTheme(t: Theme) {
  document.documentElement.dataset.theme = t;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", t === "dark" ? "#071833" : "#1C4B82");
}

export function setTheme(t: Theme) {
  try { localStorage.setItem(KEY, t); } catch { /* private mode: still applies for this visit */ }
  applyTheme(t);
  window.dispatchEvent(new CustomEvent("c2c-theme", { detail: t }));
}

/** Chrome on Android hands us its install prompt once; keep it for the Settings button. */
let deferred: (Event & { prompt: () => Promise<void> }) | null = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e as typeof deferred;
  window.dispatchEvent(new Event("c2c-installable"));
});
export const canInstall = () => deferred !== null;
export async function install(): Promise<boolean> {
  if (!deferred) return false;
  await deferred.prompt();
  deferred = null;
  return true;
}
export const isInstalled = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  (navigator as Navigator & { standalone?: boolean }).standalone === true;
